import React, {useContext, useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {API, baseURL} from "../services/api";
import AuthContext from './shared/AuthContext';
import {useTranslation} from "react-i18next";
import OrgContext from "../organisation/OrgContext";
import axios from "axios";
import Swal from "sweetalert2";

/**
 *
 * @param props (template,requiredCsvHeaders,apiSaveUrl,id)
 * @returns {JSX.Element}
 * @constructor
 */
const ImportItems = (props) => {
    const [alertDisplay, setAlertDisplay] = useState('none');
    const [file, setFile] = useState();
    const fileReader = new FileReader();
    const [allHasBeenimported, setAllHasBeenimported] = useState('none');
    const [progressBarDIsplay, setProgressBarDIsplay] = useState('none');
    const [progressBarWith, setProgressBarWith] = useState(0);
    const {user, logout} = useContext(AuthContext);
    const [t, i18n] = useTranslation();
    const {organisation, changeOrg} = useContext(OrgContext);
    const [importedData, setImportedData] = useState([]);
    const [units, setUnits] = useState([]);
    const [salesAccounts, setSalesAccounts] = useState([]);
    const [purchaseAccounts, setPurchaseAccounts] = useState([]);
    const [taxes, setTaxes] = useState([]);
    const [ativateFillTable, setAtivateFillTable] = useState(false);
    const [activateLoader, setActivateLoader] = useState(false);
    const [importSteps, setImportSteps] = useState(1);
    const [activateAlert, setActivateAlert] = useState('none');
    const [errorRequired, setErrorRequired] = useState('none');
    const [displaySteps,setDisplaySteps] = useState('none');
    const csvHandleOnChange = (e) => {
        setFile(e.target.files[0]);
    };
    const csvHandleOnSubmit = (e) => {
        e.preventDefault();
        if (file) {
            fileReader.onload = function (event) {
                const text = event.target.result;
                csvFileToArray(text);
            };

            fileReader.readAsText(file);
        }
    };
    const csvFileToArray = string => {
        const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
        const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

        const array = csvRows.map(i => {
            const values = i.split(",");
            const obj = csvHeader.reduce((object, header, index) => {
                object[header] = values[index];
                return object;
            }, {});
            return obj;
        });
        if (isValidHeaders(csvHeader)) {
            if (props.id === 'article') {
                if (importSteps === 2) {
                    console.log("araliya data :", finalImportedArray)
                    if (checkAllinputsAreFilled()) {
                        setErrorRequired('none');
                        importItems(finalImportedArray);
                    } else {
                        setErrorRequired('block');
                    }
                } else {
                    setAlertDisplay("none");
                    console.log("csvHeader: ", csvHeader);
                    console.log(",props.requiredCsvHeaders: ", props.requiredCsvHeaders);
                    setAtivateFillTable(true);
                    setImportSteps(2);
                    setImportedData(array);
                }
            } else if (props.id === 'client' || props.id === 'fournisseur') {
                setAlertDisplay("none");
                importItems(array);
            }

        } else {
            setAlertDisplay("block");
        }

        // setArray(array);
    };
    const checkAllinputsAreFilled = () => {
        for (let i = 1; i < finalImportedArray.length; i++) {
            if (
                finalImportedArray[i]['unite'] === undefined ||
                finalImportedArray[i]['taxe_vente'] === undefined ||
                finalImportedArray[i]['taxe_achat'] === undefined ||
                finalImportedArray[i]['compte_vente'] === undefined ||
                finalImportedArray[i]['compte_achat'] === undefined
            ) {
                return false;
            }
        }
        return true;
    }
    const importItems = (data) => {
        let calcProgressBar = 100 / data.length;
        let progressBarValue = 0;
        if (props.id === 'client' || props.id === 'fournisseur') {
            let leType='';
            if(props.id === 'client'){
                leType='client';
            }else if(props.id === 'fournisseur'){
                leType='fournisseurs';
            }
            setProgressBarDIsplay('block');
            for (let i = 0; i < data.length; i++) {
                const preparedData = {
                    name: data[i]["nom"],
                    lastName: data[i]["prénom"],
                    type: leType,
                    email: data[i]["email"],
                    companyName: data[i]["nom de la société"],
                    phoneNumber: data[i]["téléphone"],
                    website: data[i]["site web"],
                    addressFacCountry: data[i]["ADRESSE DE FACTURATION: pays"],
                    addressFacCity: data[i]["ADRESSE DE FACTURATION: ville"],
                    addressFacCodePostal: data[i]["ADRESSE DE FACTURATION: code postal"],
                    addressFacOthers: data[i]["ADRESSE DE FACTURATION: addresse"],
                    addressLivCountry: (data[i]['Utiliser addresse de facturation comme adresse de livraison'] === 'oui') ? data[i]["ADRESSE DE FACTURATION: pays"] : data[i]["ADRESSE DE LIVRAISON: pays"],
                    addressLivCity: (data[i]['Utiliser addresse de facturation comme adresse de livraison'] === 'oui') ? data[i]["ADRESSE DE FACTURATION: ville"] : data[i]["ADRESSE DE LIVRAISON: ville"],
                    addressLivCodePostal: (data[i]['Utiliser addresse de facturation comme adresse de livraison'] === 'oui') ? data[i]["ADRESSE DE FACTURATION: code postal"] : data[i]["ADRESSE DE LIVRAISON: code postal\r"],
                    addressLivOthers: (data[i]['Utiliser addresse de facturation comme adresse de livraison'] === 'oui') ? data[i]["ADRESSE DE FACTURATION: addresse"] : data[i]["ADRESSE DE LIVRAISON: addresse"],
                    user_id: user.id,
                    ice: data[i]["ice"],
                    organization_id: organisation.id
                }
                saveImportedItem(preparedData);

                progressBarValue = progressBarValue + calcProgressBar;
                setProgressBarWith(progressBarValue);
            }
            setAllHasBeenimported("block");
        } else if (props.id === 'article') {
            setProgressBarDIsplay('block');
            for (let i = 1; i < finalImportedArray.length; i++) {
                const preparedData = {
                    type: finalImportedArray[i]["type"],
                    name: finalImportedArray[i]["nom"],
                    unit_id: data[i]["unite"],
                    sellingPrice: data[i]["Prix de vente"],
                    salesAccount_id: data[i]["compte_vente"],
                    sellingInfosDescription: data[i]["Description sur les information de vente"],
                    costPrice: data[i]["Prix de revient"],
                    purchaseAccount_id: data[i]["compte_achat"],
                    purchaseInfosDescription: data[i]["Description sur les information de d'achat"],
                    qty: data[i]['Quantité\r'],
                    user_id: user.id,
                    taxevente: data[i]["taxe_vente"],
                    taxeachat: data[i]["taxe_achat"],
                    organization_id: organisation.id
                }
                saveImportedItem(preparedData);
                //document.location.reload();
            }
        }


    }
    const saveImportedItem = async (client) => {
        if (props.id === 'article') {
            const response = await API.post(props.apiSaveUrl, client).then(res => {
                document.location.reload();
            }).catch((error) => console.log(error));
        } else {
            const response = await API.post(props.apiSaveUrl, client).then(res => {
                document.location.reload();
            }).catch((error) => console.log(error));
        }

    }
    const isValidHeaders = (csvHeader) => {
        console.log("csvHeader : ", csvHeader);
        console.log("requiredCsvFileHeaders : ", props.requiredCsvHeaders);
        let areSimilar = true;
        for (let i = 0; i < csvHeader.length; i++) {
            if (csvHeader[i] !== props.requiredCsvHeaders[i])
                areSimilar = false;
        }
        return areSimilar;
    }
    const getTaxes = async () => {
        await axios
            .get(baseURL + "/taxes")
            .then((response) => {
                setTaxes(response.data.data);
            })
            .catch((error) => console.log("error while retrieving purshaseaccounts : " + error))
    }
    const getSalesAccount = async () => {
        // We run axios, a promise is returned
        await axios
            .get(baseURL + "/salesaccounts")
            .then((response) => {
                setSalesAccounts(response.data.data);
            })
            .catch((error) => console.log("error while retrieving setSalesAccounts : " + error))
    }
    const getPurchaseAccount = async () => {
        // We run axios, a promise is returned
        await axios
            .get(baseURL + "/purshaseaccounts")
            .then((response) => {
                setPurchaseAccounts(response.data.data);
            })
            .catch((error) => console.log("error while retrieving purshaseaccounts : " + error))
    }
    const getUnits = async () => {
        // We run axios, a promise is returned
        await axios
            .get(baseURL + "/units")
            .then((response) => {
                setUnits(response.data.data);
            })
            .catch((error) => console.log("error while retrieving units : " + error))
    }
    useEffect(() => {
        if(props.id === 'article'){
            setDisplaySteps('block');
        }
        getUnits();
        getSalesAccount();
        getPurchaseAccount();
        getTaxes();
    }, []);
    let index = 0;
    let finalImportedArray = [];
    return (
        <>
            <button type="button"
                    className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                className="fe fe-avatar" data-bs-toggle="modal"
                data-bs-target="#fullscreenmodal">importer</i></button>

            <div className="modal fade" id="fullscreenmodal" tabIndex="-1"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className={(props.id === 'client' || props.id === 'fournisseur') ? 'modal-dialog' : 'modal-dialog modal-fullscreen'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Importer les {props.id}s</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="col-12" style={{display: alertDisplay}}>
                                <div className="card border p-0 pb-3">
                                    <div className="card-header border-0 pt-3">
                                        <div className="card-options">
                                            <a href="javascript:void(0)"
                                               className="card-options-remove"
                                               data-bs-toggle="card-remove"><i
                                                className="fe fe-x"></i></a>
                                        </div>
                                    </div>
                                    <div className="card-body text-center">
                                                                <span className=""><svg
                                                                    xmlns="http://www.w3.org/2000/svg" height="60"
                                                                    width="60" viewBox="0 0 24 24"><path fill="#fad383"
                                                                                                         d="M15.728,22H8.272a1.00014,1.00014,0,0,1-.707-.293l-5.272-5.272A1.00014,1.00014,0,0,1,2,15.728V8.272a1.00014,1.00014,0,0,1,.293-.707l5.272-5.272A1.00014,1.00014,0,0,1,8.272,2H15.728a1.00014,1.00014,0,0,1,.707.293l5.272,5.272A1.00014,1.00014,0,0,1,22,8.272V15.728a1.00014,1.00014,0,0,1-.293.707l-5.272,5.272A1.00014,1.00014,0,0,1,15.728,22Z"></path><circle
                                                                    cx="12" cy="16" r="1" fill="#f7b731"></circle><path
                                                                    fill="#f7b731"
                                                                    d="M12,13a1,1,0,0,1-1-1V8a1,1,0,0,1,2,0v4A1,1,0,0,1,12,13Z"></path></svg></span>
                                        <h4 className="h4 mb-0 mt-3">Alert</h4>
                                        <p className="card-text">
                                            Les colonnes obligatoires sont manquantes,Veuillez
                                            Téléchargez un fichier <a
                                            href={props.template}>csv d’exemple</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="vtimeline">
                                <div className="timeline-wrapper timeline-wrapper-primary">
                                    <div className="avatar avatar-md timeline-badge">
                                                    <span className="timeline-icon">
                                                        <i className="fe fe-download me-2"></i>
                                                    </span>
                                    </div>
                                    <div className="timeline-panel">
                                        <div className="timeline-heading">
                                            <h6 className="timeline-title">
                                                Téléchargez un fichier csv d’exemple et
                                                comparez-le à votre fichier d’importation pour
                                                vous assurer d’avoir le fichier parfait pour
                                                l’importation.
                                            </h6>
                                        </div>
                                        <div className="timeline-body">
                                            <p className="fe fe-download me-2 ">
                                                <a href={props.template}> Télécharger le fichier
                                                    d'exemple</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="timeline-wrapper timeline-inverted timeline-wrapper-secondary">
                                    <div className="avatar avatar-md timeline-badge">
                                                    <span className="timeline-icon">
                                                        <i className="fe fe-upload me-2"></i>
                                                    </span>
                                    </div>
                                    <div className="timeline-panel">
                                        <div className="timeline-heading">
                                            <h6 className="timeline-title">Importer le fichier
                                                csv</h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="dropify-wrapper" style={{height: 100.6}}>
                                    <div className="dropify-message">
                                                                <span
                                                                    className="file-icon"> <p>{t("alert_drop")}</p></span>
                                        <p className="dropify-error">Ooops, something wrong
                                            appended.</p>
                                    </div>
                                    <div className="dropify-loader"></div>
                                    <div className="dropify-errors-container">
                                        <ul></ul>
                                    </div>
                                    <input
                                        className="dropify"
                                        data-height="180"
                                        type={"file"}
                                        id={"csvFileInput"}
                                        accept={".csv"}
                                        onChange={csvHandleOnChange}
                                    />
                                    <button type="button" className="dropify-clear">Remove
                                    </button>
                                    <div className="dropify-preview"><span
                                        className="dropify-render"></span>
                                        <div className="dropify-infos">
                                            <div className="dropify-infos-inner"><p
                                                className="dropify-filename"><span
                                                className="dropify-filename-inner"></span></p><p
                                                className="dropify-infos-message">Drag and drop
                                                or
                                                click to replace</p></div>
                                        </div>
                                    </div>

                                </div>
                                <div className="fillRequiredDataStep"
                                     style={{display: `${(props.id === 'article') ? 'block' : 'none'}`}}>
                                    <div className="timeline-wrapper timeline-inverted timeline-wrapper-secondary">
                                    </div>
                                    <div className="timeline-wrapper timeline-wrapper-primary">
                                        <div className="avatar avatar-md timeline-badge">
                                                    <span className="timeline-icon">
                                                        <i className="fe fe-edit me-2"></i>
                                                    </span>
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h6 className="timeline-title">
                                                    Remplir les données requises
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row">
                                    <p color={"red"} style={{display: `${errorRequired}`}}>
                                        <div class="alert alert-danger" role="alert">
                                            <button type="button" className="btn-close" data-bs-dismiss="alert"
                                                    aria-hidden="true">×
                                            </button>
                                            <i class="fa fa-frown-o me-2" aria-hidden="true"></i>
                                            Veuillez remplir les données requises
                                        </div>
                                    </p>
                                </div>
                            </div>
                            <br/>
                            <div className="tableToFill"
                                 style={{display: `${(props.id === 'article' && ativateFillTable === true) ? 'block' : 'none'}`}}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table border table-hover">
                                                <thead>
                                                <tr>
                                                    <th>type</th>
                                                    <th>nom</th>
                                                    <th>Unité</th>
                                                    <th>Quantité</th>

                                                    <th>prix de vente</th>
                                                    <th>Compte</th>
                                                    <th>Taxe sur vente</th>

                                                    <th>prix d'achat</th>
                                                    <th>Compte</th>
                                                    <th>Taxe sur achat</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {

                                                    importedData.map((row) => {
                                                        index++;
                                                        finalImportedArray[index] = row;
                                                        // console.log("data " ,row);
                                                        return (
                                                            <tr>
                                                                <td>{row['type']}</td>
                                                                <td>{row['nom']}</td>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <div className="input-group mb-3">
                                                                            <select className="form-select"
                                                                                    id="inputGroupSelect01"
                                                                                    onChange={(e) => {
                                                                                        row['unite'] = e.target.value;
                                                                                        // finalImportedArray[index] = [];
                                                                                        finalImportedArray[index] = row;

                                                                                    }}>
                                                                                <option selected value='0'>Séléctionnez
                                                                                    une unité
                                                                                </option>
                                                                                {
                                                                                    units.map((unit) => (
                                                                                        <option
                                                                                            value={unit.id}>{unit.name}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{row['Quantité\r']}</td>
                                                                <td>{row['Prix de vente']}</td>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <select className="form-select"
                                                                                id="buyPriceAccountInput"
                                                                                onChange={(e) => {
                                                                                    row['compte_vente'] = e.target.value;
                                                                                    // finalImportedArray[index] = [];
                                                                                    finalImportedArray[index] = row;
                                                                                }}
                                                                        >
                                                                            {
                                                                                salesAccounts.map((account) => {
                                                                                    if (account.name === "Sales") {
                                                                                        return <option
                                                                                            value={account.id}
                                                                                            selected>{account.name}</option>;
                                                                                    }
                                                                                    return <option
                                                                                        value={account.id}>{account.name}</option>;
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <div className="input-group mb-3">
                                                                            <select className="form-select"
                                                                                    id="inputGroupSelect01"
                                                                                    onChange={(e) => {
                                                                                        row['taxe_vente'] = e.target.value;
                                                                                        // finalImportedArray[index] = [];
                                                                                        finalImportedArray[index] = row;
                                                                                    }}
                                                                            >
                                                                                <option selected value='0'>Séléctionnez
                                                                                    un Taxe
                                                                                </option>
                                                                                {
                                                                                    taxes.map((taxe) => (
                                                                                        <option
                                                                                            value={taxe.id}>{taxe.name}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{row['Prix de revient']}</td>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <select className='form-select'
                                                                                id="costPriceAccountInput"
                                                                                onChange={(e) => {
                                                                                    row['compte_achat'] = e.target.value;
                                                                                    // finalImportedArray[index] = [];
                                                                                    finalImportedArray[index] = row;
                                                                                }}
                                                                        >
                                                                            {
                                                                                purchaseAccounts.map((account) => {
                                                                                        if (account.name === "Cost of Goods Sold") {
                                                                                            return <option
                                                                                                value={account.id}
                                                                                                selected>{account.name}</option>;
                                                                                        }
                                                                                        return <option
                                                                                            value={account.id}>{account.name}</option>;
                                                                                    }
                                                                                )
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <div className="input-group mb-3">
                                                                            <select className="form-select"
                                                                                    id="inputGroupSelect01"
                                                                                    onChange={(e) => {
                                                                                        row['taxe_achat'] = e.target.value;
                                                                                        // finalImportedArray[index] = [];
                                                                                        finalImportedArray[index] = row;
                                                                                    }}
                                                                            >
                                                                                <option selected value='0'>Séléctionnez
                                                                                    un Taxe
                                                                                </option>
                                                                                {
                                                                                    taxes.map((taxe) => (
                                                                                        <option
                                                                                            value={taxe.id}>{taxe.name}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        );
                                                    })
                                                }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="alert alert-success" role="alert"
                                 style={{display: allHasBeenimported}}>
                                                        <span className="alert-inner--icon"><i
                                                            className="fe fe-thumbs-up"></i></span>
                                <span className="alert-inner--text"><strong>Success!</strong>C'est importer avec success</span>
                            </div>

                            <div className="progress progress-md" style={{
                                display: progressBarDIsplay,
                                width: progressBarWith + "%"
                            }}>
                                <div className="progress-bar bg-info"
                                     style={{width: "10"}}> {progressBarWith}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer"
                             style={{justifyContent: `${(props.id === 'article') ? 'center' : ''}`}}>
                            <button id="importerBTN" type="button" className="btn btn-primary"
                                    onClick={(e) => {
                                        csvHandleOnSubmit(e);
                                    }}
                            >
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      style={{display: `${(props.id === 'article' && activateLoader === true) ? 'block' : 'none'}`}}></span>
                                Importer
                                <span> <span style={{display:`${displaySteps}`}}>{importSteps}/2</span></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ImportItems;